/** IPA SCHOOL LIBRARY
 * Global Authentication State
 * src/store/auth/index.js
 */

import { createSlice } from "@reduxjs/toolkit";
import { login, checkLogin } from "./actions";

// Initial State
const initialState = {
  loading: false,
  isLoggedIn: false,
  auth_checked: false,
  access_token: "",
  user: null,
};

// Authentication Slice
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      /** LOGOUT
       * Logs out the user by
       * setting isLoggedIn to false
       * and access_token to empty
       */
      state.isLoggedIn = false;
      state.access_token = "";
    },
  },

  extraReducers: {
    // Login Actions
    [login.pending]: (state) => {
      state.loading = true;
    },
    [login.fulfilled]: (state, action) => {
      /** LOGIN
       * Logs in the user by
       * setting isLoggedIn to true
       * and assignning access_token and user data
       * returned from API
       */
      state.loading = false;
      state.isLoggedIn = true;
      state.user = action.payload.user;
      state.access_token = action.payload.access_token;
    },
    [login.rejected]: (state) => {
      state.loading = false;
      state.access_token = "";
    },
    // Check Login Actions
    [checkLogin.pending]: (state) => {
      state.loading = true;
    },
    [checkLogin.fulfilled]: (state, action) => {
      state.user = action.payload.data;
      state.isLoggedIn = true;
      state.loading = false;
      state.auth_checked = true;
    },
    [checkLogin.rejected]: (state) => {
      state.loading = false;
      state.auth_checked = true;
    },
  },
});

export { login };
export const { logout } = authSlice.actions;
export default authSlice.reducer;
